<!-- eslint-disable-line vue/multi-word-component-names -->
<template>
  <PageNavbar :showLogout="false" />
    <LoginLanding v-if="enableLandingPage" :title="title" />
    <div style="display: inline-flex; flex-direction: column; margin: auto; background-color: var(--p-card-background);">
      <div style="margin-top: 50px">
        <h3 style="text-align: center">
          {{ title }}
        </h3>
        <p style="text-align: center">
          Don't have an account? <RouterLink to="/create">Sign up</RouterLink>
        </p>
      </div>
      <div v-if="state.showSigninSpinner" class="container-fluid">
        <LoadingComponent />
      </div>
      <div v-else class="container-fluid" style="">
        <!-- TODO: make little tabs at the top right coner -->
        <!-- https://getbootstrap.com/docs/5.3/layout/grid/#grid-options -->
        <SignInCard class="text-center" style="width: 344px" />
        <Divider layout="vertical"><b>OR</b></Divider>
        <Divider layout="horizontal"><b>OR</b></Divider>
        <MiscLoginMethods
          v-if="!state.showSigninSpinner"
          class="text-center"
          style="width: 344px"
        />
      </div>
    </div>
  <PageFooter v-if="!state.showSigninSpinner" />
</template>

<script setup lang="ts" charset="utf-8">
import { reactive, ref, onMounted } from 'vue';
import { LocationQueryValue, useRoute } from 'vue-router';
import Divider from 'primevue/divider';
import { useToast } from "primevue/usetoast";

import PageNavbar from '@/components/PageNavbar.vue';
import PageFooter from '@/components/PageFooter.vue';
import SignInCard from '@/components/SignInCard.vue';
import LoginLanding from '@/components/LoginLanding.vue';
import MiscLoginMethods from '@/components/MiscLoginMethods.vue';
import LoadingComponent from '@/components/LoadingComponent.vue';

import { config } from '@/config';

const route = useRoute();
const toast = useToast();

const redirectQuery = (() => {
  const redirect = route.query.redirect as LocationQueryValue;
  if (!redirect) return {};

  const url = new URL(redirect, window.location.origin);
  return Object.fromEntries(url.searchParams);
})();

const flow = (() => {
  if (!redirectQuery) return 'login';

  return redirectQuery.flow ?? 'login';
})() as 'login' | 'register';
const title = flow === 'register' ? 'Sign in to register your account!' : 'Sign in';
const enableLandingPage = ref(config.subsmgmt.enableLandingPage);

// TODO: dedup the same code from SignIncard/MiscLoginMethods.vue
const signin = redirectQuery.signin;
let redirect = (route.query.redirect as LocationQueryValue) ?? '/';
const decodedRedirect = decodeURIComponent(route.query.redirect as string);
const params = new URL(decodedRedirect, window.location.origin).searchParams;

const state = reactive<{
  showSigninSpinner: boolean,
}>({
  showSigninSpinner: signin === 'apple' || signin === 'google'
});

const loginWith = (provider: 'apple' | 'google' | 'zitadel') => {
  window.sessionStorage.setItem('redirect', redirect);
  window.location.href = `/auth/${provider}`;
};

onMounted(() => {
  if (route.query.passwordChanged === 'true') {
    toast.add({
      severity: 'success',
      summary: 'Password Changed',
      detail: 'Your password was successfully changed!',
      life: 5000,
    });
  }

  if (route.query.accountCreated === 'true') {
    toast.add({
      severity: 'success',
      summary: 'Account Created',
      detail: 'An account has been successfully created for you!',
      life: 5000,
    });
  }

  if (signin && (signin === 'apple' || signin === 'google')) {
    params.delete('signin');
    redirect = redirect.split('?')[0] + '?' + params.toString();
    loginWith(signin);
  }
});
</script>

<style scoped>
@media (width <= 704px) {
  div.container-fluid {
    display: flex;
    flex-direction: column;
  }
  .p-divider-vertical {
    display: none;
  }
}

@media (width > 704px) {
  div.container-fluid {
    display: flex;
    flex-direction: row;
  }
  .p-divider-horizontal {
    display: none;
  }
}
</style>
